<template>
  <div class="wrapper">
    <p class="is-size-7 has-text-centered">Select an exiting document from your library</p>
    <b-input type="search" size="is-small" v-model="filter" icon="search" class="filter-box" />
    <p class="has-text-centered">
      <font-awesome-icon icon="spinner" spin v-show="isLoading" />
    </p>
    <b-notification v-if="hasError" type="is-warning" :closable="false">
      We were not able to load your document library. Please try refreshing the page.
      <pre>
        {{ errorDetails }}
      </pre>
    </b-notification>
    <ul>
      <li v-for="document in filteredDocuments" :Key="document.documentKey">
        <b-checkbox-button size="is-small" v-model="selectedDocumentKeys" :native-value="document.documentKey">Add to transaction</b-checkbox-button>
        <span class="document-name">
          <!--
          <span class="document-category">({{documentTypeMap[document.documentType]}})</span>
          -->
          {{ document.documentName }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import documentTypeMap from '@/lookup-data/document-types'

export default {
  name: 'DocumentUploader-PickFromLib',
  created() {
    this.selectedDocumentKeys = [...this.value.map((document) => document.documentKey)]
    this.fetch()
  },

  props: {
    value: {
      type: Array
    }
  },

  data() {
    return {
      documentTypeMap,
      filter: '',
      isLoading: false,
      hasError: false,
      errorDetails: null,
      // allDocuments: [],
      selectedDocumentKeys: []
    }
  },

  computed: {
    ...mapGetters('user', ['accountInfo']),
    ...mapState('companyDocuments', { allDocuments: 'list' }),

    selectedDocuments() {
      return this.allDocuments.filter((document) => this.selectedDocumentKeys.includes(document.documentKey))
    },

    filteredDocuments() {
      const filterValue = this.filter.toLowerCase()

      // TODO: include documentType as well
      return this.allDocuments.filter((document) => document.documentName.toLowerCase().includes(filterValue))
    }
  },

  methods: {
    ...mapActions('companyDocuments', { fetchCompanyDocuments: 'fetch' }),
    async fetch() {
      this.isLoading = true
      this.hasError = false
      try {
        // this.allDocuments = await DocumentsApi.list({ companyKey: this.accountInfo.company.companyKey })
        await this.fetchCompanyDocuments()
      } catch (error) {
        this.hasError = true
        this.errorDetails = error.message
      } finally {
        this.isLoading = false
      }
    }
  },

  watch: {
    selectedDocumentKeys() {
      this.$emit('input', this.selectedDocuments)
    }
  }
}
</script>

<style scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

h5 {
  font-size: 1.3rem;
  text-align: center;
}

.filter-box {
  width: 60%;
  margin: auto;
  min-width: 150px;
}

ul {
  flex: 1;
  overflow: auto;
  margin-top: 16px;
  padding: 0 10px;
}

li {
  display: flex;
  margin: 8px 0;
  align-items: center;
}
.document-name {
  margin-left: 8px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.document-category {
  font-size: 0.65rem;
}
</style>
